import { ContentBlock } from '@fortem-monorepo/web-sdk'

import { DataGridBlock } from '@/components/content-blocks/blocks/data-grid/DataGridBlock'
import {
  DataGridBlockOverrides,
  DataGridContentBlock,
} from '@/components/content-blocks/blocks/data-grid/types'
import { ContentBlockRenderContext } from '@/components/content-blocks/context'

export interface ContentBlockRendererProps {
  block: ContentBlock
  context: ContentBlockRenderContext
  dataGridOverrides?: DataGridBlockOverrides
}

export const ContentBlockRenderer: React.FC<ContentBlockRendererProps> = ({
  block,
  context,
  dataGridOverrides,
}) => {
  if (isDataGridContentBlock(block)) {
    return (
      <DataGridBlock block={block} context={context} override={dataGridOverrides?.[block.id]} />
    )
  }

  return null
}

const isDataGridContentBlock = (block: ContentBlock): block is DataGridContentBlock => {
  const candidate = block as Partial<DataGridContentBlock>
  return (
    block.type === 'data_grid' && Array.isArray(candidate.columns) && Array.isArray(candidate.rows)
  )
}
